var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAmbassador = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8B4FE3",
  fillRule: "evenodd",
  d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-5.393-7.26c-.236-.807-1.386-1.007-1.928-.335l-2.144 2.659a1.1 1.1 0 0 1-.594.37L5.808 8.942c-.581.143-.926.691-.77 1.224l.946 3.238c.155.533.753.849 1.334.706l6.133-1.507c.238-.058.49-.04.717.05l3.306 1.319c.837.333 1.724-.367 1.487-1.175zM6.85 16.367c-.156-.533.189-1.08.77-1.223l2.279-.56c.581-.143 1.179.173 1.334.706l.846 2.893c.156.533-.19 1.081-.77 1.224l-2.28.56c-.58.142-1.178-.174-1.334-.707z",
  clipRule: "evenodd",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgAmbassador;